import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, IconButton } from "@mui/material";
import { snackbarSelector } from "../../modules/messaggio/selectors";
import { Snackbar as SnackbarMUI } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { resetSnackbarStateAction } from "../../modules/messaggio/actions";
import { OPERATION_ERROR, OPERATION_SUCCEDED } from "../../global/messaggioLabels";


export const Snackbar = () => {
    const dispatch = useDispatch()
    const snackbar = useSelector(snackbarSelector)
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        dispatch(resetSnackbarStateAction());
        setOpen(false)
    }

    const [strutturaSnackbar, setStrutturaSnackbar] = useState({
        titolo: "",
        severity: "success",
    });

    useEffect(() => {
        switch (snackbar) {
            case OPERATION_SUCCEDED:
                setStrutturaSnackbar({
                    titolo: "Operazione eseguita con successo",
                    severity: "success"
                })
                setOpen(true)
                break;

            case OPERATION_ERROR:
                setStrutturaSnackbar({
                    titolo: "Operazione fallita",
                    severity: "error"
                })
                setOpen(true)
                break;

            default:
                break;
        }
    }, [dispatch, snackbar])

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => {
                    handleClose()
                }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );


    return (
        <>

            <SnackbarMUI
                open={open}
                autoHideDuration={5000}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                onClose={() => handleClose()}
            >
                <Alert variant="filled" severity={strutturaSnackbar.severity} sx={{ width: '100%' }} action={action}>
                    {strutturaSnackbar.titolo}
                </Alert>
            </SnackbarMUI>
        </>
    );
}